<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/rasp",
		    "name": "Runtime Application Self Protection"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>Runtime Application Self Protection</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}} </h2>
          <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request A
            Demo</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none subbanner" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
        <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request A
          Demo</a>
        <a class="btn-rectangle btn-transparent btn ml-2" href="tel:8850106650">
          <!-- <i class="fa fa-phone" aria-hidden="true"></i>  -->
          <img src="assets/images/app-protectt/phone_icon.png" alt="Phone">
          +91-8850106650
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <!-- <span style="color: #da2b27;">Innovativeness</span> -->
            <div class="mt-30">
              <h2>New Digital Landscape </h2>
            </div>
            <p>Global economy is witnessing unprecedented digital transformation and surge in use of Mobile Apps and
              online Payments. In India, during the month of October, there were more than 2 Billion UPI transactions
              apart from Mobile banking transactions. At the same time, there is record increase in hacking & fraud
              attempts on mobile banking transactions and app thus impacting digital trust while causing financial loss
              to businesses and customers.</p>
            <p>As per Gartner, the Mobile Apps from any sector viz. finance, education, insurance, travel, food ordering
              etc. need to be able to detect and mitigate cyber threats at their end. This can only be achieved if the
              Apps are incorporated with <strong> Runtime Application Self Protection (RASP).</strong></p>

          </div>
        </div>
      </div>
      <div class="col-lg-6 order-md-first">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/rasp/img-3.webp" class="og_image_url" alt="Secure Digital and UPI Transactions ">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <!-- <span style="color: #da2b27;">Our clients</span> -->
            <div class="mt-30">
              <h2>Experience AppProtectt for RASP Benefits</h2>
            </div>
            <p>Mobile Applications are advised to enhance its security with Runtime Application Self Protection (RASP).
              But, at the same time businesses need to focus on the customer experience. </p>
            <p>AppProtectt bridges the gap between customer and Mobile App Security by providing RASP benefits. The
              expertise and sound knowledge of the Protectt.ai allows you to work seamlessly on customer experience
              and leave App Security onto us.</p>
            <div class="content text-left mt-5">
              <!-- <a style="color: #fff;" routerLink="/appprotectt" class="btn contact-btn mt-30 btn-circle">Learn More</a> -->
              <a style="color: #fff;" routerLink="/appprotectt" class="btn contact-btn mt-30 btn-rectangle">Learn
                More</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/rasp/img-4.webp" alt="Features of AppProtectt RASP">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<div class="section-testimonial-carousel section-pb">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title text-center">
          <h2>Protectt.ai Mobile Device Security Offerings</h2>
        </div>
      </div>
    </div>
    <ngx-slick-carousel class="carousel col-md-12 rasp-carousel newcard" #slickModal="slick-carousel" [config]="slide1Config"
      (init)="slick1Init()" (breakpoint)="breakpoint1()" (afterChange)="afterChange1()"
      (beforeChange)="beforeChange1()">
      <div ngxSlickItem *ngFor="let slide of slides1" class="slide">
        <!-- <img src="{{ slide.img }}" alt="slide" width="90%" height="180px"> -->
        <div class="card height-180px my-0 mx-2">
          <div class="card-body d-flex align-items-center text-uppercase text-center justify-content-center">
            <h4 class="card-title">{{slide.text}}</h4>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</div>

<div class="prestigiouscustomers">
  <div class="container fewofcust">
    <div class="row">
      <div class="col-md-12 text-center section-title mt-30">
        <h4>Few of Our Prestigious Customers</h4>
      </div>
    </div>
    <ul class="row mt-30 prestigiouscustul">
    
      <li><img class="img-fluid" src="assets/images/new/bsemain.webp" alt="BSE Experience The New">
      </li>
      <li><img class="img-fluid" src="assets/images/new/RBL_Bank.webp" alt="RBL Bank"></li>
      <li><img class="img-fluid" src="assets/images/new/Yes_Bank_logo.webp" alt="YES Bank"></li>
      <li><img class="img-fluid" src="assets/images/new/fincare.webp" alt="Fincare"></li>
      <li><img class="img-fluid" src="assets/images/new/Chola-MS.webp" alt="Chola MS"></li>
      <li><img class="img-fluid" src="assets/images/new/iifl_home.webp" alt="IIFL Home Loan"></li>
      <li><img class="img-fluid" src="assets/images/new/iifl_security.webp" alt="IIFL Securities">
      </li>
      <li><img class="img-fluid" src="assets/images/new/suryoday_logo.webp" alt="SURYODAY"></li>
      <li><img class="img-fluid" src="assets/images/new/fusion_logo.webp" alt="FUSION"></li>
      <li><img class="img-fluid" src="assets/images/new/pharmatica.webp" alt="PRAMERICA"></li>
      <li><img class="img-fluid" src="assets/images/new/ageas_fedral.webp" alt="ageasFEDERAL"></li>
      <li><img class="img-fluid" src="assets/images/new/equitas_logo.webp" alt="Equitas"></li>
      <li><img class="img-fluid" src="assets/images/new/iifl_finance.webp" alt="IIFL Finance"></li>
      <li><img class="img-fluid" src="assets/images/new/india_icc.webp" alt="INDIA ICC"></li>
      <li><img class="img-fluid" src="assets/images/new/india_inx.webp" alt="INDIA INX"></li>
      <li><img class="img-fluid" src="assets/images/new/kinara.webp" alt="KINARA CAPITAL"></li>
      <li><img class="img-fluid" src="assets/images/new/midgate.webp" alt="MINDGATE"></li>
      <li><img class="img-fluid" src="assets/images/new/iccl.webp" alt="ICCL"></li>
      <li><img class="img-fluid" src="assets/images/new/5paisa.webp" alt="5Paisa"></li>
      <li><img class="img-fluid" src="assets/images/new/ed_prime.webp" alt="ED PRIME"></li>

    </ul>
  </div>
</div>
<div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div style="background: #163e6f" class="p-2">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()" #closebutton>
          <span style="color: #fff" aria-hidden="true">&times;</span>
        </button>
        <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
          Contact Us
        </h4>
        <h6 style="color: #fff">Discuss your cyber security needs</h6>
      </div>
      <div style="display: block" class="modal-header text-center">
        <p class="formparagraph1">Protectt.ai cherish your excellent decision Talk to Protectt.ai
          to
          learn more about how we can secure your mobile app and its data, by filling out the form below.
          For
          product support, please visit our contact sales page.
        </p>
      </div>
      <div class="modal-body mx-3">
        <form [formGroup]="demoForm" class="contactusform">
          <div class="row">

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
              <input type="text" placeholder="Enter Your Name" id="form34" class="form-control validate input"
                formControlName="name" name="name"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email*</label>
              <input type="email" placeholder="Enter Your Email " formControlName="email" class="form-control input"
                id="email" name="email" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                Number*</label>
              <input type="text" placeholder="Enter Your Phone Number" id="form34" class="form-control validate input"
                formControlName="contactnumber" name="contactnumber"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                </div>
                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                  Mobile
                  Number.
                </div>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company*</label>
              <input type="text" placeholder="Enter Your Company Name" id="form34" class="form-control validate input"
                formControlName="company_name" name="company_name"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Designation*</label>
              <input type="text" placeholder="Enter Your Designation" id="form34" class="form-control validate input"
                formControlName="designation" name="designation"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                Slot
                1*</label>
              <input type="datetime-local" id="form34" class="form-control validate input" formControlName="time_slot1"
                name="time_slot1" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
              </div>
            </div>
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                Slot
                2*</label>
              <input type="datetime-local" id="form34" class="form-control validate input" formControlName="time_slot2"
                name="time_slot2" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot2.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.time_slot2.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.time_slot2.errors.required">* This field is required</div>
              </div>
            </div>
          </div>
          <div class="md-form">
            <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
              you?</label>
            <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
              class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close" (click)="onReset()">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>